import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./component/Navbar";
import Childdetails from "./component/Childdetails";
import Parentdetails from "./component/Parentdetails";
import Submission from "./component/Submission";
import Footer from "./component/Footer";
import "./component/css/enrollment-ui.css";

function App() {
  return (
    <BrowserRouter>
      {/* <Navbar /> */}
      <Routes>
        <Route path="/" element={<Navbar />} />
        <Route path="/:daycareId/:daycareCode/" element={<Navbar />} />

        <Route exact path="./component/Childdetails" element={<Childdetails />} />

        <Route path="/component/Parentdetails" element={<Parentdetails />} />
        {/*  <Route
          path="./component/ChildHealthDetails"
          element={<ChildHealthDetails />}
        />
        <Route
          path="./component/Emergencycontact"
          element={<Emergencycontact />}
        /> */}
        <Route path="./component/Submission" element={<Submission />} />
      </Routes>
      <Footer /> {/* <- This shows on all pages */}
    </BrowserRouter>
  );
}

export default App;
